/** Datos de contacto, enlaces y endpoints del sitio. */

export const WHATSAPP_URL = 'https://wa.me/message/GE4ZJ6YCJB3LE1'

export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xkjnwebv'

/** Mensajes previos para cada intención de contacto por WhatsApp. */
export const WHATSAPP_MESSAGES = {
  lanzaTuEmpresa:
    'Hola, vi el plan Lanza tu Empresa de Inkova y me gustaría recibir información para comenzar mi negocio en Florida.',
  presenciaDigital:
    'Hola, vi el servicio de Presencia Profesional Digital de Inkova y me gustaría conocer más información.',
  fullCreation:
    'Hola, vi Inkova Full Creation y me interesa conocer cómo funciona el servicio completo para construir mi negocio.',
} as const

export function whatsappUrl(message?: string): string {
  if (!message) return WHATSAPP_URL
  return `${WHATSAPP_URL}?text=${encodeURIComponent(message)}`
}

export const PAGE_TITLE = 'Crear tu negocio en Florida | Inkova'

export const PAGE_DESCRIPTION =
  'Convierte tu idea en un negocio con estructura. Inkova te acompaña con LLC, EIN, identidad y presencia digital para comenzar profesionalmente en Florida.'
